import { AxiosInstance } from 'axios'

import { CustomizeInstantResponseRequests } from '../interfaces/Integrations'

import Resource from '../resource'
import Constants from '../../lib/Constants'

const actions = (client: AxiosInstance): CustomizeInstantResponseRequests => ({
  checkFacebookPageToken: (params) => {
    return client.post(Constants.Backend.Endpoints.LAMBDA_PROXY, {
      name: 'FacebookIntegration',
      payload: {
        locationId: params.locationId,
        taskType: 'checkPageToken',
        uid: params.userId,
      },
    })
  },
  connectGoogleAccount: (params) => {
    return client.post(Constants.Backend.Endpoints.LAMBDA_PROXY, {
      name: 'GoogleMessagesIntegration',
      payload: {
        details: {
          locationId: params.locationId,
          email: params.email,
          fullName: params.fullName,
          googlePlaceId: params.googlePlaceId,
          website: params.website,
        },
        taskType: 'connect',
        uid: params.userId,
      },
    })
  },
  connectIntegration: (params) => {
    return client.post(Constants.Backend.Endpoints.CORE_CLIENT_PROXY, {
      module: 'Locations.Integrations',
      method: 'connect',
      params: {
        integration: params.integration,
        locationId: params.locationId,
        syncConfig: params.syncConfig,
        status: params.status,
      },
    })
  },
  disconnectIntegration(params) {
    return this.connectIntegration({ ...params, syncConfig: {} })
  },
  handleThumbtackCode: (params) => {
    return client.post(Constants.Backend.Endpoints.LAMBDA_PROXY, {
      name: 'ThumbtackIntegration',
      payload: {
        taskType: 'exchangeAccessToken',
        details: {
          locationId: params.locationId,
          code: params.code,
        },
      },
    })
  },
  sendAngiLeadsConnectEmail: (params) => {
    return client.post(Constants.Backend.Endpoints.LAMBDA_PROXY, {
      name: 'IntegrationsHelper',
      payload: {
        locationId: params.locationId,
        task: 'sendAngiLeadsConnectEmail',
        params: {
          accountNumber: params.accountNumber,
          companyName: params.companyName,
          email: params.email,
          firstName: params.firstName,
          lastName: params.lastName,
        },
      },
    })
  },
  connectFacebook: ({ locationId, userToken }) => {
    return client.post(`/v3/locations/${locationId}/integrations/facebook`, {
      userToken,
    })
  },
  disconnectFacebook: (locationId) => {
    return client.delete(`/v3/locations/${locationId}/integrations/facebook`)
  },
})

export default Resource(actions)
